import { render, staticRenderFns } from "./checkMobileDc.vue?vue&type=template&id=ccd59b12&scoped=true"
import script from "./checkMobileDc.vue?vue&type=script&lang=js"
export * from "./checkMobileDc.vue?vue&type=script&lang=js"
import style0 from "./checkMobileDc.vue?vue&type=style&index=0&id=ccd59b12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd59b12",
  null
  
)

export default component.exports